/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import * as m from "react-dom";
import l from "prop-types";
import { dispatchEvent as p, validatePackage as d, ZIndexContext as f, classNames as h } from "@progress/kendo-react-common";
import { isTooltipElement as u, getDomRect as g, getLeftPosition as E, getTopPosition as v } from "./utils.mjs";
import { packageMetadata as I } from "../package-metadata.mjs";
const T = 100, r = class r extends n.PureComponent {
  constructor(s) {
    super(s), this.context = 0, this.state = {
      targetElement: null,
      open: !1,
      title: ""
    }, this.top = 0, this.left = 0, this.willOpen = !1, this.handleMouseOut = (t) => {
      const { targetElement: e } = this.state, o = e ? e.ownerDocument : document;
      let i = o && o.elementFromPoint(t.clientX, t.clientY);
      u(i) || this.props.open || (clearInterval(this.updateIntervalId), this.willOpen = !1, this.onClose(t));
    }, this.handleMouseOver = (t) => {
      const e = t.target;
      !this.isVisible(e) || u(e) || e === this.state.targetElement || this.showToolTip(t);
    }, this.handleBodyMousemove = (t) => {
      this.top = t.clientY, this.left = t.clientX;
    }, this.onClose = (t) => {
      p(this.props.onClose, t, this, void 0), this.setState({ targetElement: null, open: !1, title: "" });
    }, this.setUpdateInterval = () => {
      this.props.updateInterval && (this.updateIntervalId = setInterval(
        this.onIntervalUpdate,
        this.props.updateInterval
      ));
    }, this.onIntervalUpdate = () => {
      const t = this.state.targetElement;
      t && (t.parentElement === null ? this.onClose({ target: t }) : this.showToolTip({ target: t }));
    }, this.position = (t) => {
      let e = g(this.state.targetElement);
      const o = E(
        this.left,
        t.offsetWidth,
        e,
        this.props.anchorElement,
        this.props.position
      ), i = v(
        this.top,
        e,
        t.offsetHeight,
        this.props.anchorElement,
        this.props.position
      );
      return { left: o, top: i };
    }, this.getTitle = (t) => {
      for (; t; ) {
        if (t.getAttribute("title") !== null || t.titleExpando)
          return { title: t.getAttribute("title") || t.titleExpando, element: t };
        t = this.props.parentTitle && t.parentElement || null;
      }
      return { title: "", element: t };
    }, this.calloutClassName = () => {
      switch (this.props.position) {
        case "bottom":
          return "k-callout k-callout-n";
        case "left":
          return "k-callout k-callout-e";
        case "right":
          return "k-callout k-callout-w";
        case "top":
          return "k-callout k-callout-s";
        default:
          return this.top < window.innerHeight / 2 ? "k-callout k-callout-n" : "k-callout k-callout-s";
      }
    }, this.getCurrentZIndex = () => this.context ? this.context : T, d(I);
  }
  /**
   * @hidden
   */
  componentDidMount() {
    document && document.body.addEventListener("mousemove", this.handleBodyMousemove);
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    clearTimeout(this.openTimeoutId), clearInterval(this.updateIntervalId), document && document.body.removeEventListener("mousemove", this.handleBodyMousemove);
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this.props.open && this.props.targetElement && this.showToolTip({ target: this.props.targetElement });
  }
  /**
   * @hidden
   */
  render() {
    if (this.props.children) {
      const { children: e, ...o } = this.props;
      let i = null;
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          onMouseOver: (a) => {
            i && i.handleMouseOver(a);
          },
          onMouseOut: (a) => {
            i && i.handleMouseOut(a);
          }
        },
        /* @__PURE__ */ n.createElement(r, { ref: (a) => i = a, ...o }),
        e
      );
    }
    if (this.props.open === !1)
      return null;
    const { targetElement: s } = this.state, t = this.getCurrentZIndex();
    return s && this.state.title && s.ownerDocument && m.createPortal(
      /* @__PURE__ */ n.createElement(
        "div",
        {
          ref: (e) => {
            if (!e)
              return;
            let o;
            if (this.props.onPosition) {
              const i = {
                element: e,
                targetElement: this.state.targetElement,
                mouseTop: this.top,
                mouseLeft: this.left,
                anchorElement: this.props.anchorElement,
                position: this.props.position,
                target: this,
                syntheticEvent: null,
                nativeEvent: null
              };
              o = this.props.onPosition.call(void 0, i);
            } else
              o = this.position(e);
            e.style.left = o.left + "px", e.style.top = o.top + "px";
          },
          className: h(
            "k-animation-container",
            "k-animation-container-fixed",
            "k-animation-container-shown",
            this.props.className
          ),
          style: {
            zIndex: t,
            ...this.props.style
          },
          tabIndex: 0
        },
        /* @__PURE__ */ n.createElement("div", { className: "k-child-animation-container" }, /* @__PURE__ */ n.createElement(
          "div",
          {
            id: this.props.id,
            role: "tooltip",
            className: h(
              "k-tooltip",
              this.props.tooltipClassName
            ),
            style: { position: "relative", ...this.props.tooltipStyle }
          },
          /* @__PURE__ */ n.createElement("div", { className: "k-tooltip-content" }, this.props.content && /* @__PURE__ */ n.createElement(this.props.content, { title: this.state.title, target: this.state.targetElement }) || this.state.title),
          this.props.showCallout && /* @__PURE__ */ n.createElement(
            "div",
            {
              ref: (e) => {
                e && (e.className = this.calloutClassName(), this.props.position === "auto" && (this.left < window.screen.availWidth / 2 ? e.style.left = this.props.setCalloutOnPositionAuto || "25%" : e.style.left = this.props.setCalloutOnPositionAuto || "75%"));
              }
            }
          )
        ))
      ),
      this.props.appendTo ? this.props.appendTo : s.ownerDocument.body
    );
  }
  showToolTip(s) {
    clearTimeout(this.openTimeoutId), clearInterval(this.updateIntervalId), s.target.hasChildNodes() && s.target.childNodes.forEach((o) => {
      o.nodeName === "title" && (s.target.titleExpando = o.innerHTML, o.remove());
    });
    const t = this.props.targetElement || s.target;
    let e = this.getTitle(t);
    if (!e.title) {
      this.state.open && this.onClose(s);
      return;
    }
    e.element && (e.element.titleExpando = e.title, e.element.title = ""), this.willOpen = !0, this.props.openDelay ? this.openTimeoutId = window.setTimeout(
      () => {
        this.willOpen && this.setState({ targetElement: t, open: !0, title: e.title }, this.setUpdateInterval);
      },
      this.props.openDelay
    ) : this.setState({ targetElement: t, open: !0, title: e.title }, this.setUpdateInterval), this.state.title !== e.title && p(this.props.onOpen, s, this, void 0);
  }
  isVisible(s) {
    return !this.props.filter || this.props.filter(s);
  }
};
r.propTypes = {
  anchorElement: l.oneOf(["pointer", "target"]),
  content: l.func,
  filter: l.func,
  openDelay: l.number,
  position: l.oneOf(["right", "left", "top", "bottom", "auto"]),
  updateInterval: l.number
}, r.defaultProps = {
  anchorElement: "pointer",
  openDelay: 400,
  position: "auto",
  showCallout: !0,
  parentTitle: !1
}, r.contextType = f;
let c = r;
export {
  c as Tooltip
};
